var map = {
	"./倾城.JPG": 2670,
	"./冬荷.JPG": 3081,
	"./惊鸿.JPG": 4239,
	"./提灯赏月.JPG": 7296,
	"./武植子莲2号.JPG": 4862,
	"./深秋香荷.jpg": 3357,
	"./秋三色.png": 2435,
	"./秋日红花.JPG": 6453,
	"./秋星.JPG": 304,
	"./秋牡丹.JPG": 8313,
	"./秋玉.jpg": 7605,
	"./秋红阳.JPG": 6666,
	"./秋艳.JPG": 5180,
	"./粉霸王.JPG": 5606,
	"./红菱蝶舞.jpg": 3146,
	"./绛芙蕖.JPG": 1306,
	"./翘首.JPG": 5552,
	"./至尊凌霄.jpg": 1866,
	"./赛凌霄.JPG": 5059,
	"./金芙蕖.png": 3953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4341;